import React from 'react';
import styled from 'styled-components';
import Logo from '@components/_common/Logo';
import { bp, colors } from '@components/_struct/variables';
import DropdownLangue from '@components/_common/DropdownLangue';
import { Container } from '../Grid';
import Footer from '@components/_struct/_layouts/Footer';
import { Link } from '@utils/i18n';

const Header = styled.div`
    position: relative;
    z-index: 20;
    width: 100%;
    padding: 15px 20px;
    display: flex;
    background: rgba(10, 14, 39, 1);
    @media (${bp.lg}) {
        background: rgba(10, 14, 39, 1);
        padding: 10px 10px;
    }
`;

const LogoCont = styled.div`
    width: 103px;
`;

const FooterCont = styled.div`
    background: #0a0e27;
    color: #fff;
    flex: 1;
`;

const Rich = styled.div`
    line-height: 1.5;
    h1 {
        position: relative;
        font-size: 3rem;
        &::before {
            content: '';
            position: absolute;
            top: -3px;
            left: -7px;
            width: 24px;
            height: 28px;
            z-index: -1;
            background-image: url("data:image/svg+xml,%3Csvg width='24' height='28' viewBox='0 0 24 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M24 14.012C24 14.0887 24 14.1655 24 14.2353V14.4236C24 14.4236 24 14.4655 24 14.4864C23.9361 14.888 23.7879 15.2677 23.5672 15.5957C23.4958 15.6958 23.4193 15.7913 23.338 15.8818C18.3577 21.8896 11.8367 26.1067 4.63076 27.9797H4.55438C4.2026 28.0068 3.84953 28.0068 3.49776 27.9797L3.08402 27.8402L2.90579 27.7495C2.85508 27.7258 2.80614 27.6978 2.75939 27.6658C2.64026 27.5847 2.5255 27.4962 2.41568 27.4007C2.14406 27.0787 1.90503 26.7255 1.70277 26.3471C1.70186 26.3262 1.70186 26.3053 1.70277 26.2844V26.2844C1.70277 26.2495 1.70278 26.2216 1.67095 26.1936C1.63913 26.1657 1.60094 25.8936 1.67095 26.082C-0.556984 18.2182 -0.556984 9.79877 1.67095 1.93499V1.93499C1.67095 1.90011 1.67095 1.86522 1.67095 1.83732C1.8088 1.35318 2.07141 0.923048 2.42715 0.598732C2.78288 0.274416 3.21657 0.0697457 3.67598 0.0093701H3.746C3.98004 -0.0115222 4.21559 0.00256154 4.44617 0.0512324H4.49072L4.63076 0.0861163C11.7838 1.95794 18.2603 6.13808 23.2235 12.0864L23.2871 12.1631C23.3508 12.2329 23.4144 12.3096 23.4717 12.3864C23.7004 12.7029 23.8595 13.0729 23.9364 13.4678C23.9534 13.5601 23.9661 13.6532 23.9745 13.7469C23.9745 13.7469 23.9745 13.8097 23.9745 13.8445L24 14.012Z' fill='%2303CE9C'/%3E%3C/svg%3E%0A");
        }
    }
    h2 {
        font-size: 2.5rem;
        font-weight: normal;
        color: ${colors.gray80};
        margin: 2rem 0 1rem;
    }
    h3 {
        font-size: 17px;
        color: ${colors.gray60};
        text-transform: uppercase;
        margin: 2rem 0 1rem;
    }
    ul {
        list-style-image: url("data:image/svg+xml,%3Csvg width='8' height='9' viewBox='0 0 8 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 4.50385C8 4.52852 8 4.55319 8 4.57562V4.63617C8 4.63617 8 4.64962 8 4.65635C7.9787 4.78542 7.92931 4.90748 7.85572 5.01292C7.83194 5.04508 7.80643 5.07577 7.77934 5.10486C6.11923 7.03593 3.94556 8.39143 1.54359 8.99348H1.51813C1.40087 9.00217 1.28318 9.00217 1.16592 8.99348L1.02801 8.94863L0.968596 8.91948C0.951694 8.91186 0.935379 8.90286 0.919798 8.89257C0.880086 8.86652 0.841833 8.83807 0.805226 8.80735C0.714687 8.70387 0.63501 8.59033 0.56759 8.46872C0.567285 8.462 0.567285 8.45527 0.56759 8.44854V8.44854C0.56759 8.43733 0.567593 8.42836 0.556984 8.41939C0.546376 8.41042 0.533645 8.32296 0.556984 8.38351C-0.185661 5.85586 -0.185661 3.14961 0.556984 0.621961V0.621961C0.556984 0.610749 0.556984 0.599536 0.556984 0.590566C0.602935 0.43495 0.690471 0.296694 0.809049 0.19245C0.927628 0.0882051 1.07219 0.0224183 1.22533 0.00301182H1.24867C1.32668 -0.00370356 1.4052 0.000823352 1.48206 0.0164676H1.49691L1.54359 0.0276803C3.92793 0.629339 6.08678 1.97296 7.74115 3.88491L7.76237 3.90957C7.78359 3.932 7.8048 3.95667 7.8239 3.98134C7.90015 4.08306 7.95315 4.20201 7.97878 4.32893C7.98446 4.35859 7.98871 4.38853 7.99151 4.41864C7.99151 4.41864 7.99151 4.43882 7.99151 4.45003L8 4.50385Z' fill='%2303CE9C'/%3E%3C/svg%3E%0A");
        li {
            margin: 2rem 0;
        }
    }
`;

const RichLayout: React.FC = props => {
    const { children } = props;

    return (
        <div className='flex flex-col h-full'>
            <Header>
                <LogoCont>
                    <Link href='/'>
                        <a>
                            <Logo variant='white' />
                        </a>
                    </Link>
                </LogoCont>
                <div className='ml-auto'>
                    <DropdownLangue variant='white' />
                </div>
            </Header>
            <div className='py-3 md:py-5 px-1'>
                <Container width='820'>
                    <Rich>{children}</Rich>
                </Container>
            </div>
            <FooterCont>
                <Footer />
            </FooterCont>
        </div>
    );
};

export default RichLayout;
